import { State } from '../StateTypes';
import { ArticleGroup, Product, Ymal } from './ymalTypes';
import { ART } from '../../constants';

/**
 * Select ymal
 * @param ymal
 * @returns {*}
 */
export const selectYmal = ({ ymal }: State): Ymal => ymal;

/**
 * Select ymal article groups
 * @param state
 * @returns {Validator<NonNullable<any[]>> | {regular: boolean, pegboard: boolean, pegboard_black: boolean}}
 */
export const selectYmalArticleGroups = (state: State): ArticleGroup[] =>
  selectYmal(state).articleGroups;

/**
 * Select ymal articles
 * @param state
 * @returns {[string, string, string, string]|[string, string, string]|[string]|[string]|[string]|[string]|*|IArticleData[]}
 */
export const selectYmalArticles = (state: State): Product[] =>
  selectYmal(state).articles;

/**
 * Select YMALs cms object
 * @param state
 */
export const selectYmalCmsObjects = (state: State) =>
  selectYmalArticles(state).map(({ id }) => ({ id, type: ART }));

/**
 * Select YMALs data
 * @param state
 */
export const selectYMALsData = (state: State) => selectYmal(state).ymal;

/**
 * Select YMAL content
 * @param state
 * @param id
 */
export const selectYMALContent = (state: State, id: any) =>
  selectYMALsData(state).find(ymal => id === ymal.content.ruItemNo).content;
